import { render, staticRenderFns } from "./SelectCoursePage.vue?vue&type=template&id=1647d4ca&scoped=true&"
import script from "./SelectCoursePage.vue?vue&type=script&lang=js&"
export * from "./SelectCoursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647d4ca",
  null
  
)

export default component.exports